<div class="flex rounded-lg flex-col" [ngClass]="{'mt-5': !useSummaryPageStyle, 'bg-white': condensed}">
  <div class="flex" [ngClass]="condensed ? 'flex-col bg-white' : 'flex-row'">
    @if (!useSummaryPageStyle) {
      <div [ngClass]="condensed ? 'w-full' : 'w-1/3 mr-2.5 max-w-[125px]'">
        <div class="w-full block bg-white rounded-lg text-center">
          <i class="bi bi-card-heading text-4xl"></i>
        </div>
      </div>
    } @else {
      <div class="w-1/3 max-w-[4.375rem] mr-[0.625rem] md:max-w-[7rem] md:mr-[1.5rem]">
        <div class="w-full block bg-white rounded-lg text-center">
          <i class="bi bi-card-heading text-4xl"></i>
        </div>
      </div>
    }

    <div [ngClass]="condensed ? 'flex-col flex px-2.5 py-[15px] basis-[130px] shrink-0': (useSummaryPageStyle ? 'flex flex-row w-full' : 'flex-col flex-1')">
      <div class="flex flex-col mr-2.5" [ngClass]="useSummaryPageStyle ? '' : 'justify-between'">
        @if (!useSummaryPageStyle) {
          <strong class="text-sm ">
            {{_orderline?.description}}
          </strong>
        } @else {
          <div class="mb-[0.125rem] font-[700] text-e-dark-green md:text-[1.25rem] text-[0.875rem]">
            {{_orderline?.description || ('subscription.recipecard_printed' | translate)}}
          </div>
          <div class="md:text-[1.25rem] text-[0.75rem]">
            {{ 'subscription.recipecard_sustainable' | translate }}
          </div>
        }
        @if (showSubscriptionlink) {
          <a class="text-sm hover:underline" [routerLink]="'/user/settings/subscriptions'">{{'subscription.no_recipecards_goto_settings' | translate }} <i class="bi bi-arrow-right-short"></i></a>
        }
      </div>


      <div class="flex flex-row flex-wrap" [ngClass]="useSummaryPageStyle ? 'mt-0 flex-grow justify-end gap-[0.5rem] md:gap-[2.5rem]' : 'mt-[15px] items-end justify-between'">
        <!-- <div class=" w-2/3  max-w-[175px]"> -->

          <!--<small>{{'common.piece' |translate : {count:quantity.value} }}</small>-->
          <!--<app-toggle *ngIf="repeatableeditable" [formControl]="repeatable">{{'subscription.product_weekly' | translate}}</app-toggle>-->

        <!-- </div> -->


        @if (useSummaryPageStyle && recipecardControl) {
          <div>
            <app-toggle class="block" [formControl]="recipecardControl" [reversed]="true"></app-toggle>
          </div>
        }

        @if (showPrice) {
          <div class="flex flex-wrap justify-end" [ngClass]="useSummaryPageStyle ? '' : 'my-auto'">
            @if (_orderline && _orderline['calculatedPrice']) {
              <pricetag [ngClass]="{'offset-7 mt-2': !qtyeditable && !repeatableeditable && !useSummaryPageStyle, 'md:text-[1.25rem] text-[0.875rem]': useSummaryPageStyle}" [calculatedPrice]="_orderline['calculatedPrice']" [couponcodeItem]="(_orderline && _orderline['couponcodeitem'])" [compensationItem]="_orderline &&_orderline['compensationitem']" [hideSmallTag]="hidePriceSmallTag"></pricetag>
            }
            @if (_productSelection && _productSelection['calculatedPrice']) {
              <pricetag [ngClass]="{'offset-7 mt-2': !qtyeditable && !repeatableeditable && !useSummaryPageStyle, 'md:text-[1.25rem] text-[0.875rem]': useSummaryPageStyle}" [calculatedPrice]="_productSelection['calculatedPrice']" [couponcodeItem]="(_productSelection && _productSelection['couponcodeitem'])" [compensationItem]="_productSelection &&_productSelection['compensationitem']" [hideSmallTag]="hidePriceSmallTag"></pricetag>
            }
            <!--<pricetag *ngIf="_repeatableProduct" [ngClass]="{'offset-7 mt-2': !editable && !repeatableeditable}" [calculatedPrice]="_repeatableProduct?.calculatedPrice" [couponcodeItem]="(_repeatableProduct && _repeatableProduct['couponcodeitem'])" [compensationItem]="_repeatableProduct &&_repeatableProduct['compensationitem']"></pricetag>-->
          </div>
        } @else if (useSummaryPageStyle && ((_orderline && _orderline['calculatedPrice']) || (_orderline && _orderline['calculatedPrice']))) {
          <div class="flex flex-wrap justify-end my-auto w-full">
            <div [ngClass]="'md:text-[1.25rem] text-[0.875rem]'">
              <pricetag [calculatedPrice]="(_orderline && _orderline['calculatedPrice']) || (_orderline && _orderline['calculatedPrice'])" [couponcodeItem]="(_orderline && _orderline['couponcodeitem']) || (_orderline && _orderline['couponcodeitem'])" [compensationItem]="(_orderline && _orderline['compensationitem']) || (_orderline && _orderline['compensationitem'])" [hideSmallTag]="hidePriceSmallTag"></pricetag>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
